import { makeStyles } from "@material-ui/core/styles";

// Estilo ÚNICO de menus (dropdown / contexto / popover) do app — mesmo padrão do
// menu do projeto (ProjectSwitcher). Reusar SEMPRE em vez de estilizar MUI cru.
// Uso:
//   const m = useMenuStyles();
//   <Menu PaperProps={{ className: m.paper }} MenuListProps={{ disablePadding: true }}>
//     <MenuItem className={m.item}><Icon/> Texto</MenuItem>
//     <MenuItem className={clsx(m.item, m.danger)}><DeleteIcon/> Excluir</MenuItem>
//   </Menu>
// Ver memória "menu-modal-design-pattern".

// pílula de item ativo (mesma do ProjectSwitcher)
const ACTIVE_BG = "#EFF8D6";

// bases reusadas pelas classes abaixo (paper/item soltos e a variante de select)
const paperBase = theme => ({
  minWidth: 200,
  marginTop: 4,
  padding: 6,
  background: "#fff",
  border: `1px solid ${theme.app.border}`,
  borderRadius: 12,
  boxShadow: "0 14px 38px rgba(27,34,42,.16)",
  color: theme.app.ink,
});

const itemBase = theme => ({
  fontSize: 12.5,
  fontWeight: 500,
  color: theme.app.ink,
  borderRadius: 8,
  padding: "8px 10px",
  gap: 11,
  marginBottom: 1,
  "& svg": { fontSize: 18, color: theme.app.textTertiary },
  "&:hover": { background: theme.app.hover },
});

export const useMenuStyles = makeStyles(theme => ({
  paper: paperBase(theme),
  item: itemBase(theme),
  danger: {
    color: theme.app.danger || "#C0453B",
    "& svg": { color: theme.app.danger || "#C0453B" },
  },
  sectionLabel: {
    padding: "6px 10px 4px",
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: theme.app.textTertiary,
  },
  divider: { height: 1, background: theme.app.border, margin: "5px 2px" },
  // Dropdown de <TextField select> / <Select>: mesmo visual do menu, mas os
  // MenuItem são estilizados por DESCENDÊNCIA — os itens são criados pelo MUI em
  // vários pontos e passar className em cada um espalharia o estilo pelo código.
  // Uso: SelectProps={{ MenuProps: { classes: { paper: m.selectPaper } } }}
  selectPaper: {
    ...paperBase(theme),
    "& .MuiList-root": { padding: 0 },
    "& .MuiMenuItem-root": { ...itemBase(theme), minHeight: "auto" },
    "& .MuiMenuItem-root.Mui-selected": {
      background: ACTIVE_BG,
      fontWeight: 600,
      "&:hover": { background: ACTIVE_BG },
    },
  },
  // Dialog/modal — mesma sobriedade: cantos arredondados + sombra difusa.
  // Uso: <Dialog PaperProps={{ className: m.dialogPaper }} ...>
  dialogPaper: {
    borderRadius: 16,
    border: `1px solid ${theme.app.border}`,
    boxShadow: "0 24px 60px rgba(16,20,26,.22)",
    // campos na mesma escala do painel de configuração do nó (NodeConfigShell):
    // o MUI põe 16px (body1) em todo input/label/checkbox — destoava do resto.
    "& .MuiInputBase-input": { fontSize: 13, letterSpacing: 0 },
    "& .MuiInputLabel-root": { fontSize: 13, letterSpacing: 0 },
    "& .MuiFormHelperText-root": { fontSize: 11.5 },
    "& .MuiFormControlLabel-label": { fontSize: 13 },
    // select focado: sem o fundo cinza padrão do MUI
    "& .MuiSelect-select:focus": { backgroundColor: "transparent" },
  },
}));

export default useMenuStyles;
